import React from 'react'

import { pushToGTM } from '../../../../shared/utis/gtm'
import { type HomepageContent } from '../../types'
import HomeLink from '../HomeLink/HomeLink'
import styles from './styles.module.scss'

type HomeHeroProps = {
  hero: HomepageContent['hero']
}

const HomeHero = ({ hero }: HomeHeroProps) => {
  const scrollToContact = () => {
    pushToGTM({ event: 'homepage_speak_with_expert', tagName: 'Homepage: Speak with an expert' })
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }

  return (
    <section
      className={styles.hero}
      aria-labelledby="homepage-hero-title"
      style={{ '--hero-image': `url(${hero.backgroundImage})` } as React.CSSProperties}
    >
      <div className={styles.overlay} />
      <div className={styles.content}>
        <div className={styles.copy}>
          <h1 id="homepage-hero-title">{hero.title}</h1>
          <p>{hero.description}</p>
          <div className={styles.actions}>
            <button type="button" className={styles.primaryCta} onClick={scrollToContact}>
              {hero.primaryCta.label}
            </button>
            <HomeLink
              className={styles.secondaryCta}
              to={hero.secondaryCta.url}
              tracking={{
                event: 'homepage_case_studies_click',
                tagName: 'Homepage: See case studies',
              }}
            >
              {hero.secondaryCta.label}
            </HomeLink>
          </div>
        </div>
        <dl className={styles.statistics}>
          {hero.statistics.map((statistic, index) => (
            <React.Fragment key={statistic.value}>
              {index > 0 ? <div className={styles.statDivider} aria-hidden="true" /> : null}
              <div className={styles.stat}>
                <dt>{statistic.value}</dt>
                <dd>
                  {statistic.prefix ? `${statistic.prefix} ` : null}
                  <strong>{statistic.emphasis}</strong> <span>{statistic.detail}</span>
                </dd>
              </div>
            </React.Fragment>
          ))}
        </dl>
      </div>
    </section>
  )
}

export default HomeHero
